import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { AiOutlineSave } from "react-icons/ai";
import { MdOutlineAddBox } from "react-icons/md";

import { updateSettings } from "../../../store/settingSlice";
import {
  useUser,
  usePost,
  useInvoice,
  useGenInvoiceNo,
  useCurrent,
  useLogs,
} from "../../../hooks";
import {
  MwToast,
  MwSpinner,
  MwButton,
  TagList,
  CardAmount,
  MwInputText,
} from "../../ui";
import CardHeadeWithActions from "../../ui/CardHeadeWithActions";
import CreateProduct from "../../Products/CreateProduct";
import CreateVendor from "../../Vendors/CreateVendor";
import CreateSalesman from "../../Salesmans/CreateSalesman";
import { getAllSalesman } from "../../../services/salesmanService";
import { getAllVendors } from "../../../services/vendorService";
import MwSpinnerButton from "../../ui/MwSpinnerButton";
import SideModal from "../../ui/SideModal";
import InvFormFooter from "./InvFormFooter";
import InvFormHeader from "./InvFormHeader";
import InvFormBody from "./InvFormBody";
import { amountFormat } from "../../../utils/invoceHelper";
import PromoCodeBox from "../PromoCodeBox";
import { formatWithCurrency } from "../../Common/formatWithCurrency";
import { HiOutlineDocumentText } from "react-icons/hi";

const InvForm = ({ tenantId, tenantUsername }) => {
  const [t, i18next] = useTranslation("global");
  const dispatch = useDispatch();
  const [disabledDiscount, setDisabledDiscount] = useState(false);
  const { currentLangId, currentCompanyId, currentBranchId, currentTenantId } =
    useCurrent();
  const companySelected = useSelector((state) => state.currentCompany);
  const branchSelected = useSelector((state) => state.currentBranch);
  const invoiceSettings = useSelector(
    (state) => state.settings,
  ).invoiceSettings;
  const [currencies, setCurrencies] = useState([]);

  const {
    SETTING_PURCHASE,
    initalProductItem,
    calcSumPrice,
    calcSumNetTotal,
    toFloat,
    calcVat,
    formatter,
  } = useInvoice();

  const INV_CURRENCY = SETTING_PURCHASE?.INV_CURRENCY;
  const SETTING_SHOW_INVOICE_PRODUCT_DESCRIPTION =
    SETTING_PURCHASE?.SHOW_INVOICE_PRODUCT_DESCRIPTION || "false";
  const SETTING_INV_WITH_HEADER_FOOTER =
    SETTING_PURCHASE?.INV_WITH_HEADER_FOOTER || "false";
  const SETTING_INV_UOM_SHOW = SETTING_PURCHASE?.INV_UOM_SHOW || "false";
  const SETTING_INV_CURRENCY = INV_CURRENCY;
  const resolveTerms = (value) => {
    if (!value) return "";
    if (typeof value !== "string") return "";
    const trimmed = value.trim();
    if (!trimmed) return "";
    const lower = trimmed.toLowerCase();
    if (["true", "false", "undefined", "null"].includes(lower)) return "";
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        const lang = String(i18next.language || "ar")
          .toLowerCase()
          .startsWith("ar")
          ? "ar"
          : "en";
        const match = parsed.find((item) => item?.lang === lang) || parsed[0];
        return match?.text || "";
      }
    } catch {}
    return trimmed;
  };
  const SETTINGTerms = resolveTerms(
    SETTING_PURCHASE?.INV_TERMS_PRINT ?? invoiceSettings?.INV_TERMS_PRINT,
  );
  const { resultLogsPost, loadingLogsPost, errorLogsPost, postDataHandler } =
    useLogs();
  const { newInvNo, loading: loadingGenInvoiceNo } = useGenInvoiceNo();
  const navigate = useNavigate();
  const { getUser } = useUser();
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  console.log("SETTING_PURCHASE", SETTING_PURCHASE);

  const {
    data: invDataPost,
    loading: invLoadingPost,
    error: invErrorPost,
    postData: invPost,
  } = usePost();
  const [formErrors, setFormErrors] = useState({});
  // products
  const [reloadProductList, setReloadProductList] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  // Customer
  const [customers, setCustomers] = useState([]);
  const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false);
  const [isAddedCustomer, setIsAddedcustomer] = useState(false);
  // Salesman
  const [salesmans, setSalesmans] = useState([]);
  const [showCreateSalesmanModal, setShowCreateSalesmanModal] = useState(false);
  const [isAddedSalesman, setIsAddedSalesman] = useState(false);
  // Toast
  const [showToast, setShowToast] = useState(false);
  const [msgToast, setMsgToast] = useState("");
  // Invoice input fields
  const [invNo, setInvNo] = useState("");
  const invRef = useRef(null);
  const invDate = useRef(null);
  const invDateDue = useRef(null);
  const invCurrency = useRef(null);
  const [customerSelected, setCustomerSelected] = useState();
  const [salesmanSelected, setSalesmanSelected] = useState();
  const [invNotes, setInvNotes] = useState("");
  const [invTerms, setInvTerms] = useState("");
  const [havePromoCode, setHavePromoCode] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [invTotalAmount, setInvTotalAmount] = useState("");
  const [totalAmountWithDiscount, setTotalAmountWithDiscount] = useState("");
  const [discount, setDiscount] = useState("");
  const [vat, setVat] = useState("");
  const [netTotal, setNetTotal] = useState("");
  const [productList, setProductList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [taxesList, setTaxesList] = useState([]);
  const [attachedFiles, setAttachedFiles] = useState([]);

  // Promo Code
  const promoCodeHandler = () => {};
  // Product Functions
  const showModalProductHandle = () => {
    setShowProductModal(true);
  };
  const onProductCreated = () => {
    setReloadProductList(true);
  };

  // Customer Functions
  const onVendorCreated = () => {
    setIsAddedcustomer(true);

    // setMsgToast('Customer Has been added...')
    // setShowToast(true);
  };
  const onClickNewCustomer = () => {
    setShowCreateCustomerModal(true);
    setIsAddedcustomer(false);
  };

  // Salesman Functions
  const onSalesmanCreated = () => {
    setIsAddedSalesman(true);
    // setMsgToast('Salesman Has been added...')
    // setShowToast(true);
  };
  const onClickNewSalesman = () => {
    setShowCreateSalesmanModal(true);
    setIsAddedSalesman(false);
  };
  const calcSum = () => {
    return calcSumPrice(productList);
  };

  const invSumHandler = () => {
    if (productList) {
      console.log("invSumHandler");
      const sum = calcSum();
      const netTotal = calcSumNetTotal(productList);
      const _discountItems = sum - netTotal;

      _discountItems > 0
        ? setDisabledDiscount(true)
        : setDisabledDiscount(false);
      if (disabledDiscount && _discountItems >= 0) {
        setDiscount(amountFormat(_discountItems));
      }
      const _totalAmountWithDiscount = sum - discount;
      setInvTotalAmount(sum);
      setTotalAmountWithDiscount(_totalAmountWithDiscount);
      vatHandler(_totalAmountWithDiscount);
    }
  };

  // const vatHandler = (total=totalAmountWithDiscount) => {
  //     const calcvat = calcVat(total)
  //     setVat(calcvat)
  //     // if(SETTING_INVOICE.PRICE_INCLUDE_VAT === 'true'){
  //     //     setNetTotal(toFloat(total))
  //     // }else{
  //         const nt = parseFloat(calcvat) + parseFloat(total);
  //         setNetTotal(nt)
  //     //}
  // }

  // const discountHandler = () => {

  //     invSumHandler();
  // }
  // add new vat handler
  const vatHandler = (total = totalAmountWithDiscount) => {
    // Total VAT is now set directly, ensuring it reflects the sum from product rows
    console.log("vat", vat);
    setVat(toFloat(vat, false)); // Ensure VAT is a float value

    // Recalculate net total based on total amount, discount, and VAT
    const invTotal = total;
    const invDiscount = toFloat(discount, false);
    const invVat = toFloat(vat, false);

    // Calculate net total: total - discount + VAT
    const net = toFloat(invTotal - invDiscount + invVat);
    setNetTotal(net);
  };

  const discountHandler = () => {
    invSumHandler();
  };
  useEffect(() => {
    if (!Array.isArray(productList)) return;
    const sum = calcSum();
    const totalVat = productList.reduce((acc, product) => {
      if (product?.productId !== "section" && product?.tax_rate !== 0) {
        return acc + (product?.productVat || 0);
      }
      return acc;
    }, 0);
    const _totalAmountWithDiscount = sum - toFloat(discount, false);

    setInvTotalAmount(sum);
    setTotalAmountWithDiscount(_totalAmountWithDiscount);
    setVat(toFloat(totalVat, false));
    setNetTotal(toFloat(_totalAmountWithDiscount + toFloat(totalVat, false)));
  }, [productList, discount]);

  const netTotalHandler = () => {
    const invTotal = totalAmountWithDiscount;
    const invDiscount = toFloat(discount, false);
    const invVat = toFloat(vat, false);
    const net = toFloat(invTotal - invDiscount + invVat);
    setNetTotal(net);
  };

  const discountOnchange = (value) => {
    const sum = calcSum();
    let discountValue;
    if (value.includes("%")) {
      invSumHandler();
      discountValue = toFloat(
        (toFloat(sum, false) * toFloat(value.replace("%", ""), false)) / 100,
      );
      console.log(discountValue);
    } else {
      discountValue = value;
    }
    setDiscount(discountValue);
  };
  const validateForm = () => {
    setFormErrors({});
    let errors = {};
    if (!invDate?.current?.value) {
      errors.invDate = "Date is required";
    }
    if (!invDateDue?.current?.value) {
      errors.invDateDue = "Date Due is required";
    }
    if (!!productList[0]?.productId === false) {
      errors.productList = "you must select a product";
    }

    if (!netTotal) {
      return;
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors({ ...errors });
      return false;
    }
    return true;
  };
  const onsubmitHandler = (e) => {
    e.preventDefault();
    if (e.key === "Enter") return;
    // validate form
    if (!validateForm()) return;
    let productListHandler = [];
    productList.map((product) => {
      if (product && product.productName !== "Deleted") {
        productListHandler.push({
          product_id: product?.productId,
          product_name: product.productName,
          unit_id: 1,
          qty: product.qty,
          uom: product.uom || "",
          product_desc: product.productDesc || "",
          uom_template_id: product.uomTemplateId || "",
          // price: (parseFloat(product.price)/parseInt(product.qty)),
          price: product.priceUnit,
          total_price: product.price,
          product_discount: product.productDiscount || 0,
          product_net_total: product.productNetTotal,
          product_vat: product.productVat,
          product_net_total_with_vat: product.productNetTotalWithVat,
          tax_id: product.tax_id ?? null,
        });
      }
    });
    const _data = {
      inv_no: invNo,
      inv_ref: invRef?.current?.value || "",
      inv_date: invDate?.current?.value,
      inv_date_due: invDateDue?.current?.value,
      customer_id: customerSelected?.value,
      customer_name: customerSelected?.label,
      // salesman_id:salesmanSelected?.value,
      // salesman_name:salesmanSelected?.label,
      total_amount: invTotalAmount,
      discount_amount: discount,
      // promo_code_id:
      // promo_code:
      vat_amount: vat,
      net_amount: netTotal,
      notes: JSON.stringify(invNotes),
      terms: JSON.stringify(invTerms),
      is_paid: false,
      type_id: 1,
      status_id: 1,
      tenant_id: tenantId,
      company_id: companySelected.value,
      branch_id: branchSelected.value,
      created_by: getUser?._id || 0,
      inv_tags: JSON.stringify(tagList),
      inv_details: productListHandler,
      attch_file: JSON.stringify(attachedFiles),
      currency_id: selectedCurrency?.value || null,
    };
    console.log("_data_from_invoice", _data);
    invPost(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/invoices`, _data);
  };

  const getcustomerHandler = async () => {
    const res = await getAllVendors(
      tenantId,
      companySelected.value,
      branchSelected.value,
    );
    setCustomers(res);
  };

  const getSalesmanHandler = async () => {
    const res = await getAllSalesman(
      tenantId,
      companySelected.value,
      branchSelected.value,
    );
    setSalesmans(res);
  };

  const setLogsHandler = (invoice) => {
    if (!invoice) return;
    const _data = {
      moduleName: "SALES",
      resourceName: "INVOICES",
      eventName: "ADD",
      logContentEn: `Add new invoice No: ${invoice.inv_no}`,
      logContentAr: `انشاء فاتورة جديدة برقم : ${invoice.inv_no}`,
    };

    postDataHandler(_data);
  };

  // Function to extract and format the currency symbol nicely
  const extractCurrencySymbol = () => {
    let formatterToUse;

    if (selectedCurrency) {
      const currencyCode = selectedCurrency.currency_code?.trim() || "SAR";

      formatterToUse = new Intl.NumberFormat(i18next.language, {
        style: "currency",
        currency: currencyCode.toUpperCase(),
      });
    } else {
      formatterToUse = formatter;
    }

    const formattedZero = formatterToUse.format(0);
    let currencySymbol = formattedZero.replace(/[0-9.,\s]/g, "");

    if (
      currencySymbol.length > 1 &&
      !/[$€£¥₹₽₺₴₿¢₱₩₫₲₸₼₾﷼]/g.test(currencySymbol)
    ) {
      currencySymbol = currencySymbol.split("").join(".");
    }

    return currencySymbol;
  };

  const currencySymbol = extractCurrencySymbol();

  useEffect(() => {
    const createdInvoice = invDataPost?.data ?? invDataPost;
    if (!createdInvoice) return;
    if (createdInvoice?.status === 0) {
      toast.error("حدث خطأ أثناء حفظ الفاتورة");
      return;
    }
    if (!createdInvoice?.id) return;
    toast.success("تم إنشاء الفاتورة بنجاح");
    const targetCompanyId = createdInvoice?.company_id || currentCompanyId;
    const targetBranchId = createdInvoice?.branch_id || currentBranchId;
    const timer = setTimeout(() => {
      navigate(
        `/${tenantUsername}/invoices/show/${createdInvoice?.id}/${targetCompanyId}/${targetBranchId}`,
      );
    }, 3000);
    return () => clearTimeout(timer);
  }, [
    invDataPost,
    navigate,
    tenantUsername,
    currentCompanyId,
    currentBranchId,
  ]);

  useEffect(() => {
    const createdInvoice = invDataPost?.data ?? invDataPost;
    if (!createdInvoice) return;
    setLogsHandler(createdInvoice);
  }, [invDataPost]);

  useEffect(() => {
    getcustomerHandler();
    getSalesmanHandler();
  }, []);

  useEffect(() => {
    if (isAddedCustomer) {
      getcustomerHandler();
    }
  }, [isAddedCustomer]);

  useEffect(() => {
    if (isAddedSalesman) {
      getSalesmanHandler();
    }
  }, [isAddedSalesman]);

  useEffect(() => {
    dispatch(
      updateSettings({
        typeSetting: "invoice",
        value: {
          INV_ITEMS_ROW_NUMBER: productList.length,
        },
      }),
    );
  }, [productList, dispatch]);

  useEffect(() => {
    if (!loadingGenInvoiceNo) {
      setInvNo(newInvNo);
    }
  }, [loadingGenInvoiceNo]);

  const onSubmitPay = () => {
    //console.log('onSubmitPay');
    navigate(
      `/${tenantUsername}/invoices/show/${invDataPost?.id}/${currentCompanyId}/${currentBranchId}`,
    );
  };
  useEffect(() => {
    const fetchCurrencies = async () => {
      const baseUrl = `${process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL}/currencies/${currentTenantId}/${currentCompanyId}`;
      try {
        const response = await fetch(baseUrl);
        if (!response.ok) {
          throw new Error("Failed to fetch currencies");
        }
        const data = await response.json();
        setCurrencies(data?.data || []);
      } catch (error) {
        console.error("Error fetching currencies:", error);
      }
    };

    if (currentTenantId && currentCompanyId) {
      fetchCurrencies();
    }
  }, [currentTenantId, currentCompanyId]);
  return (
    <>
      {showToast && (
        <MwToast msg={msgToast} isShow={showToast} setIsShow={setShowToast} />
      )}

      <SideModal
        title="Create New Product"
        onShow={showProductModal}
        setOnShow={setShowProductModal}
      >
        <CreateProduct
          onProductCreated={onProductCreated}
          setReloadProductList={setReloadProductList}
        />
      </SideModal>

      {/* <MwModal title="Create New Product" onShow={showProductModal} setOnShow={setShowProductModal} >
                <CreateProduct onProductCreated={onProductCreated} setReloadProductList={setReloadProductList}  />
            </MwModal> */}

      <SideModal
        title="Create New Customer"
        onShow={showCreateCustomerModal}
        setOnShow={setShowCreateCustomerModal}
      >
        <CreateVendor onVendorCreated={onVendorCreated} />
      </SideModal>

      <SideModal
        title="Create New Salesman"
        onShow={showCreateSalesmanModal}
        setOnShow={setShowCreateSalesmanModal}
      >
        <CreateSalesman onSalesmanCreated={onSalesmanCreated} />
      </SideModal>

      {loadingGenInvoiceNo && <MwSpinner />}
      {!loadingGenInvoiceNo && (
        <form onSubmit={onsubmitHandler} className="flex flex-col gap-6 pb-3">
          <CardHeadeWithActions
            title={t("pagesTitles.createInvoice")}
            icon={<MdOutlineAddBox size={24} />}
          >
            {invLoadingPost ? (
              <MwSpinnerButton />
            ) : (
              <>
                <MwButton
                  inGroup={true}
                  type="saveBtn"
                  onClick={()=>navigate(`/${tenantUsername}/invoices`)}
                  classNameCustom="hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                >
                  <HiOutlineDocumentText size={18} /> {t("menu.Invoices")}
                </MwButton>
                <MwButton
                  actionType="submit"
                  inGroup={true}
                  type="saveBtn"
                  classNameCustom="hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                >
                  <AiOutlineSave size={18} /> {t("invoice.saveInvoice")}
                </MwButton>
              </>
            )}
          </CardHeadeWithActions>
          <div className="px-3 mt-[-10px]">
            <div className="flex flex-col h-full bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden divide-y divide-gray-100">
              {/* Header Section */}
              <div className="p-6 mt-[-10px] ">
                <div className="mb-4">
                  <h3 className="text-xs font-semibold text-[#251658] uppercase tracking-wider">
                    البيانات الأساسية
                  </h3>
                </div>
                <InvFormHeader
                  invNo={invNo}
                  setInvNo={setInvNo}
                  invRef={invRef}
                  invDate={invDate}
                  invDateDue={invDateDue}
                  invCurrency={invCurrency}
                  customers={customers}
                  onClickNewCustomer={onClickNewCustomer}
                  salesmans={salesmans}
                  onClickNewSalesman={onClickNewSalesman}
                  customerSelected={customerSelected}
                  setCustomerSelected={setCustomerSelected}
                  salesmanSelected={salesmanSelected}
                  setSalesmanSelected={setSalesmanSelected}
                  formErrors={formErrors}
                  SETTING_INVOICE={SETTING_PURCHASE}
                  taxesList={taxesList}
                  setTaxesList={setTaxesList}
                  selectedCurrency={selectedCurrency}
                  setSelectedCurrency={setSelectedCurrency}
                  currencySymbol={currencySymbol}
                  setCurrencies={setCurrencies}
                  currencies={currencies}
                />
              </div>

              {/* Tags & Promo Section */}
              <div className="p-6 bg-gray-50 hover:bg-gray-100 transition-colors duration-300">
                <div className="mb-4">
                  <h3 className="text-xs font-semibold text-[#251658] uppercase tracking-wider">
                    الإضافات
                  </h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="p-4 bg-white rounded-xl border border-gray-200">
                    <TagList tagList={tagList} setTagList={setTagList} />
                  </div>
                  <div className="p-4 bg-white rounded-xl border border-gray-200">
                    <PromoCodeBox
                      havePromoCode={havePromoCode}
                      setHavePromoCode={setHavePromoCode}
                      promoCode={promoCode}
                      setPromoCode={setPromoCode}
                      promoCodeHandler={promoCodeHandler}
                    />
                  </div>
                </div>
              </div>

              {/* Body Section */}
              <div className="p-6 flex-1 overflow-auto bg-white">
                <div className="mb-4">
                  <h3 className="text-xs font-semibold text-[#251658] uppercase tracking-wider">
                    التفاصيل
                  </h3>
                </div>
                <InvFormBody
                  SETTING_SHOW_INVOICE_PRODUCT_DESCRIPTION={
                    SETTING_SHOW_INVOICE_PRODUCT_DESCRIPTION
                  }
                  SETTING_INV_UOM_SHOW={SETTING_INV_UOM_SHOW}
                  initalProductItem={initalProductItem}
                  reloadProductList={reloadProductList}
                  showModalProductHandle={showModalProductHandle}
                  productList={productList}
                  setProductList={setProductList}
                  formErrors={formErrors}
                  SETTING_PRICE_INCLUDE_VAT={SETTING_PURCHASE.PRICE_INCLUDE_VAT}
                  setInvNotes={setInvNotes}
                  setInvTerms={setInvTerms}
                  SETTINGTerms={SETTINGTerms}
                  setVat={setVat}
                  invoiceSettings={invoiceSettings}
                  taxesList={taxesList}
                  setTaxesList={setTaxesList}
                  attachedFiles={attachedFiles}
                  setAttachedFiles={setAttachedFiles}
                />
              </div>

              {/* Footer Section */}
              <div className="p-6 bg-gradient-to-b from-gray-50 to-white border-t-2 border-gray-200 hover:from-gray-100 transition-colors duration-300">
                <div className="mb-4">
                  <h3 className="text-xs font-semibold text-[#251658] uppercase tracking-wider">
                    الملخص المالي
                  </h3>
                </div>
                <InvFormFooter
                  invNotes={invNotes}
                  setInvNotes={setInvNotes}
                  invTotalAmount={invTotalAmount}
                  totalAmountWithDiscount={totalAmountWithDiscount}
                  invCurrency={invCurrency}
                  promoCode={promoCode}
                  setPromoCode={setPromoCode}
                  discount={discount}
                  vat={vat}
                  netTotal={netTotal}
                  havePromoCode={havePromoCode}
                  setHavePromoCode={setHavePromoCode}
                  promoCodeHandler={promoCodeHandler}
                  discountOnchange={discountOnchange}
                  SETTING_PRICE_INCLUDE_VAT={SETTING_PURCHASE.PRICE_INCLUDE_VAT}
                  SETTING_INV_CURRENCY={SETTING_INV_CURRENCY}
                  tagList={tagList}
                  setTagList={setTagList}
                  disabledDiscount={disabledDiscount}
                  formatter={formatter}
                  formatWithCurrency={formatWithCurrency}
                  selectedCurrency={selectedCurrency}
                />
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
};

export default InvForm;
